import { render } from "./MastMeldung.vue?vue&type=template&id=74575b77&scoped=true&ts=true"
import script from "./MastMeldung.vue?vue&type=script&lang=ts"
export * from "./MastMeldung.vue?vue&type=script&lang=ts"

import "./MastMeldung.vue?vue&type=style&index=0&id=74575b77&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74575b77"]])

export default __exports__